export const services = [
  {
    title: "Comprehensive Construction Methodology",
    information: "",
    image: "/Construction Methodology Examples/Header and Button PNG.png",
    link: "/home_service/construction_methodology",
  },
  {
    title: "Custom 3D Modelling & BIM",
    information: "",
    image: "/3D Modeling Examples/Button and Header PNG.png",
    link: "/home_service/3d_modeling",
  },
  {
    title: "Custom Site Simulations",
    information: "",
    image: "/Construction Simulation Examples/Button and Header PNG.png",
    link: "/home_service/site_simulations",
  },
];
